import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorDoesNotHaveRFCToEnableAutomaticInvoicing extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Does Not Have RFC To Enable Automatic Invoicing', options);
    }
}
export default InvestorDoesNotHaveRFCToEnableAutomaticInvoicing;
